export const arrayUnique = (arr: Array<any>) => {
  return Array.from(new Set(arr));
};

export const arraySum = <T>(arr: Array<T>, prop?: keyof T) => {
  return arr.reduce((sum, item) => {
    const val = prop ? +item[prop] : +item;
    return sum + val;
  }, 0);
};

export function addOrRemove<T>(array: Array<T>, item: T): Array<T> {
  const exists = array.includes(item);
  return exists ? array.filter(i => i !== item) : [...array, item];
}

export function move<T>(
  array: Array<T>,
  sourceIndex: number,
  destinationIndex: number
) {
  if (
    sourceIndex < 0 ||
    sourceIndex >= array.length ||
    destinationIndex < 0 ||
    destinationIndex >= array.length ||
    sourceIndex === destinationIndex
  ) {
    return;
  }

  const item = array.splice(sourceIndex, 1)[0];
  array.splice(destinationIndex, 0, item);
}
